export const navItem = () => ({
    display: 'flex',
    alignItems: 'flex-start',

    '> .anticon': {
        flexShrink: 0,
    },
});
